import { Authorize, Login } from 'features/auth';
import React from 'react';
import { Route } from 'react-router-dom';
import { ApmRoutes as Routes } from '@elastic/apm-rum-react';
import {
  CreatePage,
  Requests,
  ServiceProvider,
  TableRequest,
  UserManagement,
} from 'views/pages';
import Insulation from 'views/pages/create-instrulation';
import PrivateRoute from './PrivateRoute';

export default (
  <Routes>
    <Route index element={<PrivateRoute component={<TableRequest />} />} />
    <Route
      path="requests"
      element={<PrivateRoute component={<Requests />} />}
    />
    <Route
      path="setting/user"
      element={<PrivateRoute component={<UserManagement />} />}
    />
    <Route
      path="setting/service-provider"
      element={<PrivateRoute component={<ServiceProvider />} />}
    />
    <Route path="insu">
      <Route
        path="create"
        element={<PrivateRoute component={<CreatePage />} />}
      />
      <Route
        path=":type/:id"
        element={<PrivateRoute component={<CreatePage />} />}
      />
    </Route>
    <Route path="insulation">
      <Route
        path="create"
        element={<PrivateRoute component={<Insulation />} />}
      />
      <Route
        path="view/:id"
        element={<PrivateRoute component={<Insulation />} />}
      />
      <Route
        path="edit/:id"
        element={<PrivateRoute component={<Insulation />} />}
      />
    </Route>
    <Route path="login" element={<Login />} />
    <Route path="Account/Authorized" element={<Authorize />} />
  </Routes>
);

export const authorized = (
  <Routes>
    <Route path="Account/Authorized" element={<Authorize />} />
  </Routes>
);
